import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import useServicePageCms from '../../hooks/useServicePageCms';
import ServicesHero from './ServicesHero';
import ServicePageBody from './ServicePageBody';

const InterventionalRadiology = () => {
  const { content } = useServicePageCms('interventional-radiology');

  return (
    <Box>
      <ServicesHero
        title={content.title}
        subtitle={content.subtitle}
        serviceType="radiology"
      />

      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
            {content.introTitle}
          </Typography>
          <Typography variant="h6" paragraph sx={{ maxWidth: 900, mx: 'auto', lineHeight: 1.8, color: 'text.secondary' }}>
            {content.introText}
          </Typography>
        </Box>

        <ServicePageBody content={content} inContainer={false} />
      </Container>
    </Box>
  );
};

export default InterventionalRadiology;
